export const getNearestQuarterDate = (now = new Date()) => {
  now.setMinutes(now.getMinutes() + 30);
  const minutes = now.getMinutes();
  const roundedMinutes = Math.floor(minutes / 15) * 15;
  now.setMinutes(roundedMinutes);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return now;
};
